<template>
    <main>
        <div class="box">
            <div class="mark"></div>
            <div class="content" v-scroll-lock="true">
                <div class="close" v-if="!option.close_btn" @click="hideAuth"></div>
                <div class="middle">
                    <div class="tit">您好，欢迎来到2026 戴尔科技峰会</div>
                    <div class="m-tit">您尚未登录，登录即可观看全部精彩直播</div>
                    <div class="btn-box">
                        <div class="btn" @click="toLogin">已报名，即刻登录</div>
                        <div class="btn" @click="toRegister">未报名，立即报名</div>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
    export default {
        name: 'auth',
        data() {
            return {}
        },
        components:{

        },
        computed:{
            option(){
                return this.$store.state.show_auth;
            }
        },
        methods: {
            toLogin(){
                if(this.option.target == '_blank'){
                    var router = this.$router.resolve({
                        path:"/login",
                        query:{
                            from:this.$store.state.show_auth.from ? this.$store.state.show_auth.from : this.$route.fullPath
                        }
                    });
                    window.open(router.href, '_blank');
                }else{
                    this.util.toLink('/login',{
                        from:this.$store.state.show_auth.from ? this.$store.state.show_auth.from : this.$route.fullPath
                    })
                }
                this.hideAuth();
            },
            toRegister(){
                if(this.option.target == '_blank'){
                    var router = this.$router.resolve({
                        path:"/register",
                        query:{
                            from:this.$store.state.show_auth.from ? this.$store.state.show_auth.from : this.$route.fullPath
                        }
                    });
                    window.open(router.href, '_blank');
                }else{
                    this.util.toLink('/register',{
                        from:this.$store.state.show_auth.from ? this.$store.state.show_auth.from : this.$route.fullPath
                    })
                }
                this.hideAuth();
            },
            hideAuth(){
                this.util.showAuth({
                    show:false
                });
            }
        },
        mounted() {
            this.query = this.$route.query;
        },
        destroyed() {
            this.hideAuth();
        }
    }
</script>

<style lang="scss" type="text/scss" scoped>
    .box{position: fixed;top:0;left:0;width: 100%;height:100%;z-index: 100;
        .mark{position: absolute;top:0;left:0;width: 100%;height:100%;background: rgba(0,0,0,.8)}
        .content{width:6.4rem;height:4.4rem;background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;background-size: cover;position:absolute;top:50%;left:50%;transform: translate(-50%,-50%);border-radius:.1rem;
            .close{width: .5rem;height:.5rem;position: absolute;top:0;right:0;background: url("~@/assets/image/54.png") no-repeat center center;background-size:.25rem;cursor: pointer;transition: background .3s ease;}
            .middle{width:6.4rem;height:4.4rem;text-align: center;
                .tit{font-size:.34rem;color:#ffffff;margin-top: .2rem;}
                .m-tit{font-size:.26rem;color:#ffffff;margin-top: .2rem;}
                .btn-box{margin-top:.4rem;
                    .btn{width: 3.2rem;height:.7rem;border-radius: .02rem;margin: 0 auto; text-align: center;line-height:.7rem;font-size: .24rem;color:#0b32a9;transition: all .3s ease;cursor: pointer;}
                    .btn:nth-child(1){background: #3bcfda;}
                    .btn:nth-child(2){background: #0b32a9;margin-top: .25rem;color: #fff;}
                    //.btn:hover{background: #00447b;transition: all .3s ease;}
                }
            }
        }
    }
</style>

